export const MAX_CONNECTION_LABEL_LENGTH = 30;

/** Чистит и обрезает пользовательскую подпись подключения до безопасного значения. */
export function normalizeConnectionLabel(value: string): string {
  return value
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .replace(/[\u202A-\u202E\u2066-\u2069]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_CONNECTION_LABEL_LENGTH);
}
